/// <reference types="@types/google.maps" />
import { Component, Input, Output, EventEmitter, Optional } from '@angular/core';

import {UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormControl} from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';

import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

import { GameService, TemplateService, MissionService, GeocodingService, LanguageService } from '../../_services/index';

import { Storage, ref, uploadString, percentage, uploadBytesResumable, UploadTask } from '@angular/fire/storage';
import { deleteField } from '@angular/fire/firestore';

import { NbDialogRef, NbDialogService, NbGlobalPhysicalPosition, NbIconConfig, NbToastrService } from '@nebular/theme';
import { ConfirmModalComponent } from '../modals/confirm-modal.component';

import { MapResources } from '../../_resources/map.resources';

import { RoleGuard } from '../../_guards/role.guard';
import { environment } from '../../../environments/environment';

import * as uuid from 'uuid'
import { MissionPreviewComponent } from '../mission-preview/mission-preview.component';

@Component({
    selector: 'app-edit-mission-param',
    templateUrl: './edit-mission-param.component.html',
    styleUrls: ['./edit-mission-param.component.scss'],
    standalone: false
})

export class EditMissionParamsComponent {

  @Input() gameId;
  _template;
  @Input()
  set template(template){
    this._template = template;
    this.loadTemplateMissions();
  }
  @Input() game;
  @Input() openMission;
  missionParams =[];

  _mission;
  @Input()
  set mission(mission) {
    //console.log('EDIT MISSION:'+JSON.stringify(mission));
    const missionSwitch = (!mission.id || !this._mission || (this._mission.id != mission.id));
    this._mission = mission;
    this.editedMission = {...mission};
    if(missionSwitch){
      this.initMissionForm();
      this.templateMissionId = this._mission.id;
    }
    this.loadMissionData();
  };

  map;
  @Input() mapTheme;
  polygon;
  mapOptions = {
    mapId: 'f6a179fc020e550d',
    mapTypeControl: true,
    panControl: true,
    zoom: 15
  }

  _missions;
  @Input()
  set missions(missions) {
    console.log('Update missions');
    this._missions = [...missions];
    setTimeout( ()=> {
      this.editedMission.geoDependencies = JSON.parse(JSON.stringify(this.editedMission.geoDependencies));
      this.deps = JSON.parse(JSON.stringify(this.deps));
      this.optionalDeps = JSON.parse(JSON.stringify(this.optionalDeps));
      this.deactivateDeps = JSON.parse(JSON.stringify(this.deactivateDeps));
      this.successMissions = JSON.parse(JSON.stringify(this.successMissions));
      this.editedMission.failMissions = JSON.parse(JSON.stringify(this.editedMission.failMissions));
      if(this.openMission){
        let index = this._missions.findIndex(mission => mission.id == this._mission.id)
        if(index>=0) this._missions.splice(index, 1);
      }
    }, 500);
  }
  templateMissions = [];
  templateMissionId;
  copyingFromTemplate;

  @Input() objects;
  @Input() resources;
  resourceQuantities = {};
  @Input() roles;
  @Input() characters;

  @Input() languages;
  editedMission;
  missionForm:UntypedFormGroup;

  icons = ['mission_marker.svg','HomeBase.png','MaleInformant.png','FemaleInformant.png','MovingTarget.png','TimedDrop.png','Bonus.png',
    'adventure_01.png','adventure_03.png','adventure_04.png','adventure_05.png','adventure_06.png','adventure_07.png','adventure_08.png','adventure_09.png'];

  customIcon;

  //dependencies: Mission[] = [];
  deps = [];
  optionalDeps = [];
  deactivateDeps = [];
  deactivateObjDeps = [];
  successMissions = [];
  successObjects = [];

  pictures = [];
  previewImage;
  //task: AngularFireUploadTask;
  progress: any;  // Observable 0 to 100
  progressMap = {};

  //map;
  mapStyles;

  geocodeError;

  riddleAnswers = [];
  newAnswer;

  forkSelections = [];
  quizzQuestions = [];
  quizzList = [];
  currentSelection;
  currentSelectionIdx;
  riddleClues = [];
  currentClueIdx;
  currentClue;

  positions = NbGlobalPhysicalPosition;

  @Output() saved = new EventEmitter();


  constructor(private router: Router,
    private route: ActivatedRoute,
    public languageService: LanguageService,
    public gameService: GameService,
    public templateService: TemplateService,
    public missionService: MissionService,
    public geocodingService: GeocodingService,
    private form: UntypedFormBuilder,
    private storage: Storage,
    private dialogService: NbDialogService,
    @Optional() private dialogRef: NbDialogRef<any>,
    public roleGuard: RoleGuard,
    private toastrService: NbToastrService) {  
      this.mapStyles = MapResources.mapStyles;
      this.initMissionForm();
  }

  checkedAtt =[]
  ngOnInit() {
    for (let index = 0; index < 13; index++) {
      this.checkedAtt.push(false)
    }
    this.checkedAtt[1] = true
    this.missionParams['MG'] = 'MG'
  }

  loadDetailParam(checked, param: string, i) {
    if(this.openMission){
      this.missionParams = []
      let checkedAtt = this.checkedAtt.map((att, index)=>{
        if(index == i) return true
        else return false
      })
      this.checkedAtt = checkedAtt
      this.missionParams[param] = param
    } else {
      this.checkedAtt[i] = !this.checkedAtt[i]
      if(this.checkedAtt[i]) this.missionParams[param] = param
      else delete this.missionParams[param]
    } 
  }

  loadMissionData(){
    this.riddleAnswers = [];
    this.forkSelections = [];
    this.quizzList = [];
    this.riddleClues = [];
    delete this.currentSelection;

    this.customIcon = this._mission.customIcon;
    
    if(this._mission.type)
      (<UntypedFormControl>this.missionForm.controls['type']).setValue(this._mission.type);
    if(this._mission.buildingType){
      (<UntypedFormControl>this.missionForm.controls['buildingType']).setValue(this._mission.buildingType);
    }
    if(this._mission.icon)
      (<UntypedFormControl>this.missionForm.controls['icon']).setValue(this._mission.icon);
    if(this._mission.active)
      (<UntypedFormControl>this.missionForm.controls['active']).setValue(this._mission.active);
    if(this._mission.optional)
      (<UntypedFormControl>this.missionForm.controls['optional']).setValue(this._mission.optional);
      
    /*if(this._mission.description)
      (<FormControl>this.missionForm.controls['description']).setValue(this._mission.description);
    if(this._mission.unlockedDescription)
      (<FormControl>this.missionForm.controls['unlockedDescription']).setValue(this._mission.unlockedDescription);*/
    (<UntypedFormControl>this.missionForm.controls['geographic']).setValue(this._mission.geographic == true);
    if(this._mission.location)
      (<UntypedFormControl>this.missionForm.controls['location']).setValue(this._mission.location);
    if(this._mission.placesSearchTerms)
      (<UntypedFormControl>this.missionForm.controls['placesSearchTerms']).setValue(this._mission.placesSearchTerms);
    if(this._mission.latitude)
      (<UntypedFormControl>this.missionForm.controls['latitude']).setValue(this._mission.latitude);
    if(this._mission.longitude)
      (<UntypedFormControl>this.missionForm.controls['longitude']).setValue(this._mission.longitude);
    if(this._mission.unlockDistance)
      (<UntypedFormControl>this.missionForm.controls['unlockDistance']).setValue(this._mission.unlockDistance);
    if(this._mission.ignoreDistance)
      (<UntypedFormControl>this.missionForm.controls['ignoreDistance']).setValue(this._mission.ignoreDistance);
    if(this._mission.ghost)
      (<UntypedFormControl>this.missionForm.controls['ghost']).setValue(this._mission.ghost);
    if(this._mission.autoActivation)
      (<UntypedFormControl>this.missionForm.controls['autoActivation']).setValue(this._mission.autoActivation);
    if(this._mission.reward != null)
      (<UntypedFormControl>this.missionForm.controls['reward']).setValue(this._mission.reward);
    if(this._mission.rewardMode)
      (<UntypedFormControl>this.missionForm.controls['rewardMode']).setValue(this._mission.rewardMode);
    if(this._mission.rewardMin != null)
      (<UntypedFormControl>this.missionForm.controls['rewardMin']).setValue(this._mission.rewardMin);
    if(this._mission.rewardMax != null)
      (<UntypedFormControl>this.missionForm.controls['rewardMax']).setValue(this._mission.rewardMax);
    if(this._mission.rewardStep != null)
      (<UntypedFormControl>this.missionForm.controls['rewardStep']).setValue(this._mission.rewardStep);
    if(this._mission.riddleAnswerMode)
      (<UntypedFormControl>this.missionForm.controls['riddleAnswerMode']).setValue(this._mission.riddleAnswerMode);
    if(this._mission.riddleAnswers)
      this.riddleAnswers = this._mission.riddleAnswers;

    if(this._mission.isBetMode)
      (<UntypedFormControl>this.missionForm.controls['isBetMode']).setValue(this._mission.isBetMode);
    if(this._mission.riddleMalus != null)
      (<UntypedFormControl>this.missionForm.controls['riddleMalus']).setValue(this._mission.riddleMalus);
    if(this._mission.hasExternalLink != null)
      (<UntypedFormControl>this.missionForm.controls['hasExternalLink']).setValue(this._mission.hasExternalLink);
      
    if(this._mission.forkSelections){
      this.forkSelections = this._mission.forkSelections;
      for(let selection of this.forkSelections){
        if(!selection.neededObjects){
          selection.neededObjects = [];
        }
      }
    }

    if(this._mission.quizzQuestions){
      this.quizzQuestions = this._mission.quizzQuestions;
    }

    if(this._mission.quizzList){
      this.quizzList = this._mission.quizzList;
    }
      
    if(this._mission.riddleClues)
      this.riddleClues = this._mission.riddleClues;
    if(this._mission.forkAllowedSelections)
      (<UntypedFormControl>this.missionForm.controls['forkAllowedSelections']).setValue(this._mission.forkAllowedSelections);

    if(this._mission.successMissions){
      this.successMissions = this._mission.successMissions;
    }
    if(this._mission.successObjects){
      this.successObjects = this._mission.successObjects;
    }
    if(this._mission.successPopup)
      (<UntypedFormControl>this.missionForm.controls['successPopup']).setValue(this._mission.successPopup);
    if(this._mission.successGotoNext)
      (<UntypedFormControl>this.missionForm.controls['successGotoNext']).setValue(this._mission.successGotoNext);
    if(this._mission.failPopup)
      (<UntypedFormControl>this.missionForm.controls['failPopup']).setValue(this._mission.failPopup);
    if(this._mission.failGotoNext)
      (<UntypedFormControl>this.missionForm.controls['failGotoNext']).setValue(this._mission.failGotoNext);
    if(this._mission.timeLimited)
      (<UntypedFormControl>this.missionForm.controls['timeLimited']).setValue(this._mission.timeLimited ? true : false);
    if(this._mission.timeLimitedManual)
      (<UntypedFormControl>this.missionForm.controls['timeLimitedManual']).setValue(this._mission.timeLimitedManual);
    if(this._mission.timeLimitedSeconds)
      (<UntypedFormControl>this.missionForm.controls['timeLimitedSeconds']).setValue(this._mission.timeLimitedSeconds);
    if(this._mission.isProgressStep)
      (<UntypedFormControl>this.missionForm.controls['isProgressStep']).setValue(this._mission.isProgressStep);
      
    (<UntypedFormControl>this.missionForm.controls['autoValidation']).setValue(this._mission.autoValidation ? true : false);
    (<UntypedFormControl>this.missionForm.controls['scoredByAdmin']).setValue(this._mission.scoredByAdmin ? true : false);
    
    (<UntypedFormControl>this.missionForm.controls['canRetry']).setValue(this._mission.canRetry ? true : false);
    (<UntypedFormControl>this.missionForm.controls['votingMode']).setValue(this._mission.votingMode ? true : false);
    if(this._mission.roleAssignMode)
    (<UntypedFormControl>this.missionForm.controls['roleAssignMode']).setValue(this._mission.roleAssignMode);
    if(this._mission.isFinalMission)
      (<UntypedFormControl>this.missionForm.controls['isFinalMission']).setValue(this._mission.isFinalMission ? true : false);
    if(this._mission.groupCustomMeetingPoint)
      (<UntypedFormControl>this.missionForm.controls['groupCustomMeetingPoint']).setValue(this._mission.groupCustomMeetingPoint ? true : false);
    
    if(this._mission.isHiddenWhileInactive)
      (<UntypedFormControl>this.missionForm.controls['isHiddenWhileInactive']).setValue(this._mission.isHiddenWhileInactive ? true : false);
    if(this._mission.customQrCode)
      (<UntypedFormControl>this.missionForm.controls['customQrCode']).setValue(this._mission.customQrCode);

    this.deps = [];
    if(this._mission.dependencies){
      for (var dependency in this._mission.dependencies){
        console.log('Dependency:'+dependency);
        this.deps.push(dependency);
      }
    }
    this.optionalDeps = [];
    if(this._mission.optionalDependencies){
      for (var dependency in this._mission.optionalDependencies){
        console.log('Dependency:'+dependency);
        this.optionalDeps.push(dependency);
      }
    }
    if(this._mission.optionalDepRequiredNbr)
      (<UntypedFormControl>this.missionForm.controls['optionalDepRequiredNbr']).setValue(this._mission.optionalDepRequiredNbr);

    if(this._mission.type == 'FZONE'){
      
      if(this._mission.fZoneReactivationSeconds){
        (<UntypedFormControl>this.missionForm.controls['fZoneReactivationSeconds']).setValue(this._mission.fZoneReactivationSeconds);
      }
      this.deactivateDeps = [];
      if(this._mission.deactivateDeps){
        for (var dependency in this._mission.deactivateDeps){
          console.log('Dependency:'+dependency);
          this.deactivateDeps.push(dependency);
        }
      }
      this.deactivateObjDeps = [];
      if(this._mission.deactivateObjDeps){
        for (var dependency in this._mission.deactivateObjDeps){
          console.log('Dependency:'+dependency);
          this.deactivateObjDeps.push(dependency);
        }
      }
      if(this._mission.markUsedObjects){
        (<UntypedFormControl>this.missionForm.controls['markUsedObjects']).setValue(this._mission.markUsedObjects);
      }
    }
    if(this.missionForm.value.type == 'FZONE' || this.missionForm.value.type == 'BUILDING'){
      this.initZone();
    }

    for(let clue of this.riddleClues){
      if(!clue.cluePic){
        clue.cluePic = {};
      }
    }

    this.missionService.listMissionPictures(this._mission.collectionPath, this._mission.id)
    .subscribe(pictures => {
      this.pictures = pictures;
    });

  }

  loadTemplateMissions(){
    //console.log('template:'+JSON.stringify(this._template));
    if(this._template){
      this.missionService.listMissions(`game_templates/${this._template.id}/missions`)
      .subscribe(templateMissions => {
        console.log('templateMissions:'+templateMissions.length);
        this.templateMissions = templateMissions;
      });
    }
  }

  changePosition(old_index, new_index){
    //this._mission.riddleClues
    if (new_index >= this._mission.riddleClues.length) {
      var k = new_index - this._mission.riddleClues.length + 1;
      while (k--) {
        this._mission.riddleClues.push(undefined);
      }
    }
    this._mission.riddleClues.splice(new_index, 0, this._mission.riddleClues.splice(old_index, 1)[0]);
    //save position
    this.savePositionRiddleClues()
  }
  savePositionRiddleClues(){
    this.missionService.updateMission(this._mission, {riddleClues: this._mission.riddleClues})
    .then(res => {
      console.log('Riddle clues position updated');
    });
  }

  initMissionForm(){
    delete this.previewImage;
    delete this.currentClue;
    this.missionForm = this.form.group({
      type: ['REWARD', [Validators.required]],
      buildingType: ['', []],
      //description: [null, [Validators.required]],
      active: [false, []],
      optional: [false, []],
      icon: [this.icons[0], []],
      unlockedDescription: ['', []],
      successPopup: [false, []],
      successGotoNext: [false, []],
      failPopup: [false, []],
      failGotoNext: [false, []],
      geographic: [true, []],
      location: ['', []],
      placesSearchTerms: ['', []],
      latitude: [0, []],
      longitude: [0, []],
      unlockDistance: [20, []],
      ignoreDistance: [false, []],
      ghost: [false, []],
      autoActivation: [false, []],
      rewardMode: ['AUTO', [Validators.required]],
      reward: [100, [Validators.required]],
      rewardMin: [0],
      rewardMax: [500],
      rewardStep: [50],
      riddleAnswerMode: ['FREETXT', []],
      riddleMalus: [30, []],
      hasExternalLink: [false, []],
      customQrCode: ['', []],
      
      isBetMode: [false, []],
      autoValidation: [false, []],
      scoredByAdmin: [false, []],
      canRetry: [true, []],
      votingMode: [false, []],
      roleAssignMode: ['AUTO', []],

      forkAllowedSelections: [1, []],
      timeLimited: [false, []],
      timeLimitedManual: [false, []],
      timeLimitedSeconds: [300, []],
      isProgressStep: [false, []],
      isHiddenWhileInactive: [false, []],
      isFinalMission: [false, []],
      groupCustomMeetingPoint: [false, []],
      optionalDepRequiredNbr: [0, []],
      fZoneReactivationSeconds: [30, []],
      markUsedObjects: [false, []],
      
      //activeFrom: [''],
      //activeTo: [''],
      //actorId : [null, []] 
    });
  }

  typeChange(){
    console.log('Type changed to:'+this.missionForm.value.type);
    if(this.missionForm.value.type == 'FZONE' || this.missionForm.value.type == 'BUILDING'){
      this.initZone();
    }
  }

  rewardModeChange(){
    console.log('Type changed to:'+this.missionForm.value.type);
    if(this.missionForm.value.rewardMode == 'RIDDLE'){
      (<UntypedFormControl>this.missionForm.controls['canRetry']).setValue(true);
    }
    else{
      (<UntypedFormControl>this.missionForm.controls['canRetry']).setValue(false);
    }
  }

  zoneTypeChange(){
    console.log('Zone type changed to:'+this.editedMission.zone.type);
    this.initZone();
  }

  switchMissionIcon(icon){
    (<UntypedFormControl>this.missionForm.controls['icon']).setValue(icon);
  }

  handleIconInputChange(e){
    var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
    console.log('handleIconInputChange');
    var pattern = /image-*/;
    var reader = new FileReader();
    let fileSize = file.size;
    if (!file.type.match(pattern)) {
        alert('invalid format');
        return;
    }

    if (fileSize>(50*1024)) {
        alert('Icon image is too big. Maximum allowed is 50kb');
        return;
    }

    console.log('File name is:'+file.name);
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    var reader = e.target;
    //console.log('_handleReaderLoaded:'+reader.result);
    this.customIcon = reader.result;
    this.editedMission.iconWidth = 30;
    this.editedMission.iconHeight = 30;
    //console.log('customIcon size:'+this.customIcon.length);
  }

  resetIcon(){
    this.customIcon = null;
    this.editedMission.iconWidth = 40;
    this.editedMission.iconHeight = 40;
  }

  mapReady(map) {
    console.log('map ready:'+map);
    this.map = map;
    if(this.mapTheme && this.mapTheme.virtualMapUrl){
      this.setMapType(this.mapTheme);
    }
    if(this.missionForm.value.type == 'FZONE' || this.missionForm.value.type == 'BUILDING'){
      this.initZone();
    }
  }

  setMapType(theme){
    var TILE_URL = theme.virtualMapUrl+ '/{z}/{x}/{y}.png';
    console.log('SWITCH MAP LAYER:'+TILE_URL);

    // Name the layer anything you like.
    var layerID = 'my_custom_layer';

    // Create a new ImageMapType layer.
    var layer = new google.maps.ImageMapType({
      name: layerID,
      getTileUrl: function(coord, zoom) {
        console.log(coord);
        var url = TILE_URL
          .replace('{x}', ''+coord.x)
          .replace('{y}', ''+coord.y)
          .replace('{z}', ''+zoom);
        return url;
      },
      tileSize: new google.maps.Size(256, 256),
      minZoom: theme.minZoom,
      maxZoom: theme.maxZoom
    });

    this.map.mapTypes.set(layerID, layer);
    this.map.setMapTypeId(layerID);
  }

  selectSuccessMissions(event){
    this.successMissions = event
  }
  selectFailedMissions(event){
    this.editedMission.failMissions = event
  }
  markerDragEnd(event){
    console.log('lat:'+ event.latLng.lat());
    console.log('lng:'+ event.latLng.lng());
    (<UntypedFormControl>this.missionForm.controls['latitude']).setValue(Math.round(event.latLng.lat() * 100000) / 100000, { onlySelf: false });
		(<UntypedFormControl>this.missionForm.controls['longitude']).setValue(Math.round(event.latLng.lng() * 100000) / 100000, { onlySelf: false });
  }

  clearLocation(){
    (<UntypedFormControl>this.missionForm.controls['location']).setValue('', { onlySelf: false });
    (<UntypedFormControl>this.missionForm.controls['latitude']).setValue(0, { onlySelf: false });
    (<UntypedFormControl>this.missionForm.controls['longitude']).setValue(0, { onlySelf: false });
  }
  
  geocode(event){
    if(event){
      event.preventDefault();
    }
		this.geocodeError = null;
		let city = this.missionForm.get('location').value;
		console.log(city);
		if(city && city != ''){
			console.log('Enough dtata to geocode');
			this.geocodingService.geocode(city,null,null)
				.subscribe(
					location => {
            console.log('Found current location:'+location.latitude+'/'+location.longitude+' -- '+location.address);
            
            (<UntypedFormControl>this.missionForm.controls['location']).setValue(location.address, { onlySelf: false });
						(<UntypedFormControl>this.missionForm.controls['latitude']).setValue(location.latitude, { onlySelf: false });
						(<UntypedFormControl>this.missionForm.controls['longitude']).setValue(location.longitude, { onlySelf: false });

						
					},
					err => {
						console.error(err);
						this.geocodeError = 'Error while geocoding: '+err;
					}
			);
		}
		else
			this.geocodeError = 'Not enough data to geocode. At least city must be specified';
  }

  //Forbidden zone/Building
  initZone(){
    if(!this.editedMission.zone){
      this.editedMission.zone = {
        type: 'circle',
        radius: 100,
        strokeColor: '#084C61',
        strokeOpacity: '1',
        strokeWeight: '1',
        fillColor: '#084C61',
        fillOpacity: '0.2'
      };
    }
    if(this.editedMission.zone.type == 'polygon' && !this.editedMission.zone.paths){
      this.editedMission.zone.paths = [
        { lat: this.missionForm.value.latitude-0.001, lng: this.missionForm.value.longitude-0.001 },
        { lat: this.missionForm.value.latitude-0.001, lng: this.missionForm.value.longitude+0.001 },
        { lat: this.missionForm.value.latitude+0.001, lng: this.missionForm.value.longitude+0.001 },
        { lat: this.missionForm.value.latitude+0.001, lng: this.missionForm.value.longitude-0.001 },
        { lat: this.missionForm.value.latitude-0.001, lng: this.missionForm.value.longitude-0.001 }
      ]
    }
    if(this.polygon){
      this.polygon.setMap(null);
    }
    if(this.editedMission.zone.type == 'polygon'){
      this.genPolygon();
    }
  }

  async genPolygon(){
    // Construct the polygon.
    console.log('genPolygon-paths:'+JSON.stringify(this.editedMission.zone.paths));
    this.polygon = new google.maps.Polygon({
      paths: this.editedMission.zone.paths,
      strokeColor: this.editedMission.zone.strokeColor,
      strokeOpacity: this.editedMission.zone.strokeOpacity,
      strokeWeight: this.editedMission.zone.strokeWeight,
      fillColor: this.editedMission.zone.fillColor,
      fillOpacity: this.editedMission.zone.fillOpacity,
      editable: true,
      draggable: true,
    });

    console.log('genPolygon-add to map:'+this.map);
    //Set polygon to map
    this.polygon.setMap(this.map);

    // this assumes `my_poly` is an normal google.maps.Polygon or Polyline
    google.maps.event.addListener(this.polygon, 'rightclick', (mev) => {
      /*this.ngZone.run(() => {
      });*/
      if (mev.vertex != null) {
        this.polygon.getPath().removeAt(mev.vertex);
      }
    });
  }

  setPolygonOptions(name){
    if(this.editedMission.zone.type == 'polygon'){
      console.log('setPolygonOptions:'+JSON.stringify(this.editedMission.zone[name]));
      let data:any = {};
      data[name] = this.editedMission.zone[name];
      this.polygon.setOptions(data);
    }
  }

  getPolygonCoordinates(draggablePolygon) {
    const len = draggablePolygon.getPath().getLength();
    const polyArrayLatLng = [];
  
    for (let i = 0; i < len; i++) {
      const vertex = draggablePolygon.getPath().getAt(i);
      const vertexLatLng = { lat: vertex.lat(), lng: vertex.lng() };
      polyArrayLatLng.push(vertexLatLng);
    }
  
    console.log(polyArrayLatLng);
    return polyArrayLatLng;
  }
  
  selectDependencies(){
    console.log('selectDependencies called');
  }

  async audioUpdated(data, pathAttribute, urlAttribute) {
    console.log('audioUpdated:'+pathAttribute);
    //console.log('customIcon size:'+this.customIcon.length);
    const filePath = `${this._mission.collectionPath}/${this._mission.id}/`;
    let fileName = `audio_${ new Date().getTime() }.mp3`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, data, 'data_url');
    let blob = await (await fetch(data)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url); // <-- do what ever you want with the url..
      this.editedMission[pathAttribute] = filePath+fileName;
      this.editedMission[urlAttribute] = url;
      let data:any = {};
      data[pathAttribute] = filePath+fileName;
      data[urlAttribute] = url;
      this.missionService.updateMission(this._mission, data)
      .then(res => {
        console.log('Audio successfully updated');
      });
      setTimeout(() => {
        delete this.progressMap[pathAttribute];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap[pathAttribute] =  Math.round(percentage.progress);
    });
  }

  deleteAudio(pathAttribute, urlAttribute){
    let data:any = {};
    data[pathAttribute] = deleteField();
    data[urlAttribute] = deleteField();
    this.missionService.updateMission(this._mission, data)
    .then(res => {
      console.log('Audio successfully updated');
      delete this.editedMission[pathAttribute];
      delete this.editedMission[urlAttribute];
    });
  }

  async riddleAudioUpdated(data, lang){
    console.log('audioUpdated:'+lang);
    //console.log('customIcon size:'+this.customIcon.length);
    const filePath = `${this._mission.collectionPath}/${this._mission.id}/`;
    let fileName = `audio_${lang}_${ new Date().getTime() }.mp3`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, data, 'data_url');
    let blob = await (await fetch(data)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url); // <-- do what ever you want with the url..
      this._mission.riddleAudio[lang] = {filePath:filePath+fileName,url:url};
      this.missionService.updateMission(this._mission, {riddleAudio:this._mission.riddleAudio})
      .then(res => {
        console.log('Riddle lang audio successfully added');
        this.editedMission.riddleAudio = this._mission.riddleAudio;
      });
      setTimeout(() => {
        delete this.progressMap['riddleAudio'+lang];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap['riddleAudio'+lang] =  Math.round(percentage.progress);
    });
  }
  
  deleteRiddleAudio(lang){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this audio?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        delete this._mission.riddleAudio[lang];
          await this.missionService.updateMission(this._mission, {riddleAudio:this._mission.riddleAudio});
          delete this.editedMission.riddleAudio;
      }
    });
  }

  async forkAudioUpdated(data, lang){
    console.log('forkAudioUpdated:'+lang);
    //console.log('customIcon size:'+this.customIcon.length);
    const filePath = `${this._mission.collectionPath}/${this._mission.id}/`;
    let fileName = `audio_${lang}_${ new Date().getTime() }.mp3`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, data, 'data_url');
    let blob = await (await fetch(data)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url); // <-- do what ever you want with the url..
      this.currentSelection.audioFilePath = filePath+fileName;
      this.currentSelection.audioUrl = url;
      this.currentSelection.lastUpdateDate = new Date().getTime();
      await this.missionService.updateMission(this._mission, {forkSelections:this.forkSelections});
      setTimeout(() => {
        delete this.progressMap['forkAudio'+lang];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap['forkAudio'+lang] =  Math.round(percentage.progress);
    });
  }
  
  deleteForkAudio(lang){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this audio?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        delete this.currentSelection.audioFilePath;
        delete this.currentSelection.audioUrl;
        this.currentSelection.lastUpdateDate = new Date().getTime();
        await this.missionService.updateMission(this._mission, {forkSelections:this.forkSelections});
      }
    });
  }

  async raQuizzAudioUpdated(data, lang){
    console.log('raQuizzAudioUpdated:'+lang);
    //console.log('customIcon size:'+this.customIcon.length);
    const filePath = `${this._mission.collectionPath}/${this._mission.id}/`;
    let fileName = `audio_${lang}_${ new Date().getTime() }.mp3`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, data, 'data_url');
    let blob = await (await fetch(data)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url); // <-- do what ever you want with the url..
      this.currentSelection.audioFilePath = filePath+fileName;
      this.currentSelection.audioUrl = url;
      this.currentSelection.lastUpdateDate = new Date().getTime();
      await this.missionService.updateMission(this._mission, {quizzQuestions:this.quizzQuestions});
      setTimeout(() => {
        delete this.progressMap['quizzAudio'+(lang || '')];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap['quizzAudio'+(lang || '')] =  Math.round(percentage.progress);
    });
  }
  
  deleteRaQuizzAudio(lang){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this audio?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        delete this.currentSelection.audioFilePath;
        this.currentSelection.lastUpdateDate = new Date().getTime();
        await this.missionService.updateMission(this._mission, {quizzQuestions:this.quizzQuestions});
      }
    });
  }

  handleFileUpdated(image, type, idx=0, lang = 'en'){
    //console.log('New document is:'+missionImage);
    this.saveMissionImage(type, idx, lang, image);
  }

  async saveMissionImage(type, idx, lang, image){
    
    const filePath = `${this._mission.collectionPath}/${this._mission.id}/`;
    let fileName = `gallery_${ new Date().getTime() }.jpg`;

    let uploadRef = ref(this.storage, filePath+fileName);
    //let task:any = uploadString(uploadRef, image, 'data_url');
    let blob = await (await fetch(image)).blob();
    console.log('Blob:'+blob);
    let task:any = uploadBytesResumable(uploadRef, blob);

    task.then(async () => {
      const url = 'https://storage.googleapis.com/'+environment.firebase.storageBucket+'/'+filePath+fileName;
      console.log('file uploaded to:'+url); // <-- do what ever you want with the url..
      if(type == 'RIDDLE'){
        this._mission.riddleUrl = url;
        this.missionService.updateMission(this._mission, {riddleFilePath:filePath+fileName, riddleUrl:url})
        .then(res => {
          console.log('Riddle image successfully added');
          this.editedMission.riddleFilePath = filePath+fileName;
          this.editedMission.riddleUrl = url;
        });
      }
      else if(type == 'RIDDLELANG'){
        this._mission.riddlePic[lang] = {filePath:filePath+fileName,url:url,lastUpdateDate:new Date().getTime()};
        this.missionService.updateMission(this._mission, {riddlePic:this._mission.riddlePic})
        .then(res => {
          console.log('Riddle lang image successfully added');
          this.editedMission.riddlePic = this._mission.riddlePic;
        });
      }
      else if(type == 'RIDDLEMULTI'){
        this.riddleAnswers[idx].filePath = filePath+fileName;
        this.riddleAnswers[idx].pictureUrl = url;
        this.riddleAnswers[idx].lastUpdateDate = new Date().getTime();
        await this.missionService.updateMission(this._mission, {riddleAnswers:this.riddleAnswers});
      }
      else if(type == 'FORK'){
        this.currentSelection.filePath = filePath+fileName;
        this.currentSelection.pictureUrl = url;
        this.currentSelection.lastUpdateDate = new Date().getTime();
        await this.missionService.updateMission(this._mission, {forkSelections:this.forkSelections});
      }
      else if(type == 'RAQUIZZ'){
        this.currentSelection.filePath = filePath+fileName;
        this.currentSelection.pictureUrl = url;
        this.currentSelection.lastUpdateDate = new Date().getTime();
        await this.missionService.updateMission(this._mission, {quizzQuestions:this.quizzQuestions});
      }
      else if(type == 'CLUE'){
        this.currentClue.filePath = filePath+fileName;
        this.currentClue.pictureUrl = url;
        this.currentClue.lastUpdateDate = new Date().getTime();
        await this.missionService.updateMission(this._mission, {riddleClues:this.riddleClues});
      }
      else if(type == 'CLUELANG'){
        this.currentClue.cluePic[lang] = {filePath:filePath+fileName,url:url,lastUpdateDate:new Date().getTime()};
        await this.missionService.updateMission(this._mission, {riddleClues:this.riddleClues});
      }
      else if(type == 'SUCCESS'){
        this._mission.successPictureUrl = url;
        this.missionService.updateMission(this._mission, {successPictureFilePath:filePath+fileName, successPictureUrl:url})
        .then(res => {
          console.log('Success image successfully added');
          this.editedMission.successPictureFilePath = filePath+fileName;
          this.editedMission.successPictureUrl = url;
        });
      }
      else if(type == 'FAIL'){
        this._mission.failPictureUrl = url;
        this.missionService.updateMission(this._mission, {failPictureFilePath:filePath+fileName, failPictureUrl:url})
        .then(res => {
          console.log('Fail image successfully added');
          this.editedMission.failPictureFilePath = filePath+fileName;
          this.editedMission.failPictureUrl = url;
        });
      }
      else{
        let data: any = {fileName: filePath+fileName, url: url};
        if(this._template){
          data.templateId = this._template.id;
        }
        if(this.gameId){
          data.gameId = this.gameId;
        }
        if(type == 'UNLOCKED'){
          data.isUnlocked = true;
        }
        if(type == 'IMG'){
          this.previewImage = image;
        }
        this.missionService.addMissionImage(this._mission, data)
        .then(res => {
          console.log('Image added to mission picture gallery');
        });
      }
      setTimeout(() => {
        delete this.progressMap[type+lang];
      }, 1000);
    });

    // Percentage observer
    percentage(task).subscribe((percentage) => {
      this.progressMap[type+lang] =  Math.round(percentage.progress);
    });
  }

  deletePicture(picture){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this picture?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(res => {
      console.log('Dialog returns:'+res);
      if(res){
        this.missionService.deleteMissionImage(this._mission, picture.id)
        .then(res => {
          console.log('Picture deleted');
        });
      }
    });
  }

  async deleteRiddlePicture(lang){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this picture?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        if(lang){
          delete this._mission.riddlePic[lang];
          await this.missionService.updateMission(this._mission, {riddlePic:this._mission.riddlePic});
          delete this.editedMission.riddlePic;
        }
        else{
          await this.missionService.updateMission(this._mission, 
            {
              riddleFilePath:deleteField(), 
              riddleUrl:deleteField(),
              riddleThumbFileName:deleteField(), 
              riddleThumbFileURL:deleteField()
            }
          );
          delete this._mission.riddleFilePath;
          delete this._mission.riddleUrl;
          delete this._mission.riddleThumbFileName;
          delete this._mission.riddleThumbFileURL;
          delete this.editedMission.riddleFilePath;
          delete this.editedMission.riddleUrl;
          delete this.editedMission.riddleThumbFileName;
          delete this.editedMission.riddleThumbFileURL;
        }
      }
    });
  }

  async deleteRiddleMultiPicture(idx){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this picture?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        delete this.riddleAnswers[idx].filePath;
        delete this.riddleAnswers[idx].pictureUrl;
        delete this.riddleAnswers[idx].lastUpdateDate;
        await this.missionService.updateMission(this._mission, 
          {
            riddleAnswers: this.riddleAnswers
          }
        );
      }
    });
  }

  async deleteCluePicture(lang){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this picture?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        if(lang){
          delete this.currentClue.cluePic[lang];
        }
        else{
          delete this.currentClue.pictureUrl;
          delete this.currentClue.filePath;
        }
      }
    });
  }

  async deleteForkPicture(lang){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this picture?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        if(lang){
          delete this.currentSelection.picture[lang];
        }
        else{
          delete this.currentSelection.pictureUrl;
          delete this.currentSelection.filePath;
        }
      }
    });
  }

  async deleteSuccessPicture(){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this picture?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        await this.missionService.updateMission(this._mission, 
          {
            successPictureFilePath:deleteField(), 
            successPictureUrl:deleteField()
          }
        );
        delete this._mission.successPictureFilePath;
        delete this._mission.successPictureUrl;
        delete this.editedMission.successPictureFilePath;
        delete this.editedMission.successPictureUrl;
      }
    });
  }

  async deleteFailPicture(){
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Are you sure you want to delete this picture?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(async res => {
      console.log('Dialog returns:'+res);
      if(res){
        await this.missionService.updateMission(this._mission, 
          {
            failPictureFilePath:deleteField(), 
            failPictureUrl:deleteField()
          }
        );
        delete this._mission.failPictureFilePath;
        delete this._mission.failPictureUrl;
        delete this.editedMission.failPictureFilePath;
        delete this.editedMission.failPictureUrl;
      }
    });
  }

  addAnswer(event){
    event.stopPropagation();
    console.log('addAnswer:'+this.newAnswer);
    console.log('Current array:'+JSON.stringify(this.riddleAnswers));
    let labels: any = {};
    labels[this.languageService.currentLang] = this.newAnswer;
    this.riddleAnswers.push({value: String(this.getNextIdx()), labels: labels, correct: false});
    this.newAnswer = null;
  }

  getNextIdx(){
    let i = this.riddleAnswers.length;
    let valid = false;
    while(!valid){
      i++;
      valid = true;
      for(let answer of this.riddleAnswers){
        if(answer.value == ''+i){
          valid = false;
        }
      }
    }
    return i;
  }

  checkAnswer(index){
    this.riddleAnswers[index].correct = !this.riddleAnswers[index].correct;
  }

  deleteAnswer(index){
    this.riddleAnswers.splice(index, 1);
  }

  isMissionValid(){
    if(this.missionForm.invalid)
      return false;

    return true;
  }

  addClue(event){
    event.stopPropagation(); 
    console.log('Current array:'+JSON.stringify(this.riddleClues));
    let newClue = {labels: {}, riddleClueMalus:20, cluePic: {}};
    this.riddleClues.push(newClue);
    this.currentClueIdx = this.riddleClues.length-1;
    this.currentClue = newClue;
  }

  editClue(clue,idx){
    this.currentClue = clue;
    this.currentClueIdx = idx;
  }

  deleteClue(index){
    this.riddleClues.splice(index, 1);
  }

  addSelection(event){
    event.stopPropagation(); 
    console.log('Current array:'+JSON.stringify(this.forkSelections));
    this.forkSelections.push({ labels: {}, correct: true, reward: 0, neededObjects: [], activateMissions:[], activateObjects:[], selectedTxt: {}, unselectedTxt: {}, neededResources: {}, selectedResources: {}});
    this.currentSelection = this.quizzQuestions[this.quizzQuestions.length-1];
  }

  addQuizzQuestion(event){
    event.stopPropagation();
    this.quizzQuestions.push({ labels: {}, activateObjects:[]});
    this.currentSelection = this.quizzQuestions[this.quizzQuestions.length-1];
  }

  checkSelection(index){
    this.forkSelections[index].correct = !this.forkSelections[index].correct;
    this.saveCheckedSelection()
  }

  saveCheckedSelection(){
    this.missionService.updateMission(this._mission, {forkSelections: this.forkSelections})
    .then(res => {
      console.log('forkSelections updated');
    });
  }

  editSelection(selection,idx){
    this.currentSelection = selection;
    if(this.game?.hasResources){
      if(!selection.selectedResources) selection.selectedResources = {};
      if(!selection.neededResources) selection.neededResources = {};
    }
    this.currentSelectionIdx = idx;
  }

  deleteSelection(index){
    this.forkSelections.splice(index, 1);
  }

  deleteQuizzQuestion(index){
    this.quizzQuestions.splice(index, 1);
  }

  addFailMessage(){
    this.editedMission.failMessageList.push({});
  }

  deleteFailMessage(index){
    this.editedMission.failMessageList.splice(index, 1);
  }

  getRole(roleId){
    if(this.roles){
      for(let role of this.roles){
        if(role.id == roleId){
          return role;
        }
      }
    }
    return null;
  }

  updateMissionOrder(){
    let i=0;
    for(let mission of this._missions){
      i++;
      if(mission.orderNum != i){
        mission.orderNum = i;
        this.missionService.updateMission(mission, {orderNum: mission.orderNum});
      }
    }
  }

  getPreviewViewMission(){
    this.dialogService.open(MissionPreviewComponent, { 
      context: {
        languages: this.languages, 
        mission: this.editedMission,
        missions: this._missions,
        objects: this.objects,
        openMission: this.openMission,
      }, closeOnBackdropClick: false
    })
  }

  deleteMission(event, mission){
    event.preventDefault();
    this.dialogService.open(ConfirmModalComponent, { 
      context: {
        title: 'Confirmation',
        message: `Do you want to delete mission '`+mission.name[this.languageService.currentLang]+`'?`
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(res => {
      console.log('Dialog returns:'+res);
      if(res){
        console.log('Delete mission');
        this.missionService.deleteMission(mission)
        .then(res => {
          console.log('Remove result:'+res);
          if(!this.openMission) this.updateMissionOrder();
          else this.close() 
        });
      }
    });
  }

  drop(event: CdkDragDrop<string[]>, list) {
    moveItemInArray(list, event.previousIndex, event.currentIndex);
  }

  close() {
    this.dialogRef.close()
  }
  
  onSubmit() {
    console.log('Submitted data:'+this.missionForm);

    let dependencies = {};
    for(let dep of this.deps){
      console.log('Add dependency:'+dep);
      dependencies[dep] = true;
    }
    let optionalDependencies = {};
    for(let dep of this.optionalDeps){
      console.log('Add dependency:'+dep);
      optionalDependencies[dep] = true;
    }

    const choiceProps = ['forkSelections', 'riddleAnswers', 'riddleClues']
    choiceProps.forEach(choiceProp => {
      this[choiceProp].forEach(choice => {
        if(choice.uid == null) choice.uid = uuid.v4()
      })
    })
    
    this.editedMission.optionalDepRequiredNbr = this.missionForm.value.optionalDepRequiredNbr;
    this.editedMission.type = this.missionForm.value.type;
    this.editedMission.buildingType = this.missionForm.value.buildingType;
    this.editedMission.active = this.missionForm.value.active;
    this.editedMission.optional = this.missionForm.value.optional;
    this.editedMission.icon = this.missionForm.value.icon;
    this.editedMission.geographic = this.missionForm.value.geographic;
    if(this.editedMission.geographic){
      this.editedMission.placesSearchTerms = this.missionForm.value.placesSearchTerms;
      this.editedMission.location = this.missionForm.value.location;
      this.editedMission.latitude = this.missionForm.value.latitude;
      this.editedMission.longitude = this.missionForm.value.longitude;
    }
    else{
      this.editedMission.location = '';
      this.editedMission.placesSearchTerms = '';
      this.editedMission.latitude = 0;
      this.editedMission.longitude = 0;
    }
    this.editedMission.unlockDistance = this.missionForm.value.unlockDistance;
    this.editedMission.ignoreDistance = this.missionForm.value.ignoreDistance;
    this.editedMission.ghost = this.missionForm.value.ghost;
    this.editedMission.autoActivation = this.missionForm.value.autoActivation;
    this.editedMission.reward = this.missionForm.value.reward;
    this.editedMission.rewardMode = this.editedMission.type == 'FORK' ? 'RIDDLE' : this.missionForm.value.rewardMode;
    this.editedMission.rewardMin = this.missionForm.value.rewardMin;
    this.editedMission.rewardMax = this.missionForm.value.rewardMax;
    this.editedMission.rewardStep = this.missionForm.value.rewardStep;
    this.editedMission.riddleAnswerMode = this.missionForm.value.riddleAnswerMode;
    this.editedMission.riddleAnswers = this.riddleAnswers;
    this.editedMission.isBetMode = this.missionForm.value.isBetMode;
    this.editedMission.autoValidation = this.missionForm.value.autoValidation;
    this.editedMission.scoredByAdmin = this.missionForm.value.scoredByAdmin;
    this.editedMission.canRetry = this.missionForm.value.canRetry;
    this.editedMission.votingMode = this.missionForm.value.votingMode;
    this.editedMission.roleAssignMode = this.missionForm.value.roleAssignMode;
    this.editedMission.riddleMalus = this.missionForm.value.riddleMalus;
    this.editedMission.hasExternalLink = this.missionForm.value.hasExternalLink;
    this.editedMission.customQrCode = this.missionForm.value.customQrCode;
    this.editedMission.successMissions = JSON.parse(JSON.stringify(this.successMissions));
    this.editedMission.successObjects = this.successObjects;

    /*CUSTOM RIDDLE */
    if(this.editedMission.customRiddleVerified){
      //this.editedMission.customRiddle = false;
      this.editedMission.customRiddleProposed = false;
    }

    /*ZONE*/
    if(this.editedMission.type == 'FZONE' || this.editedMission.type == 'BUILDING'){
      this.editedMission.fZoneReactivationSeconds = this.missionForm.value.fZoneReactivationSeconds;
      let deactDependencies = {};
      for(let dep of this.deactivateDeps){
        console.log('Add dependency:'+dep);
        deactDependencies[dep] = true;
      }
      this.editedMission.deactivateDeps = deactDependencies;

      let deactObjDependencies = {};
      for(let dep of this.deactivateObjDeps){
        console.log('Add dependency:'+dep);
        deactObjDependencies[dep] = true;
      }
      this.editedMission.deactivateObjDeps = deactObjDependencies;
      this.editedMission.markUsedObjects = this.missionForm.value.markUsedObjects;

      if(this.editedMission.zone.type == 'polygon'){
        this.editedMission.zone.paths = this.getPolygonCoordinates(this.polygon);
        /*console.log('Test point inside polygon');
        console.log('Contains1:'+this.pointInPolygon(this.editedMission.zone.paths, {lat:this.editedMission.latitude, lng:this.editedMission.longitude}));
        console.log('Contains2:'+this.pointInPolygon(this.editedMission.zone.paths, {lat:1, lng:10}));*/
      }
      else{
        delete this.editedMission.zone.paths;
      }
    }
    else{
      delete this.editedMission.zone;
      if(this._mission.id){
        this.editedMission.deactivateDeps = deleteField();
        this.editedMission.deactivateObjDeps = deleteField();
        this.editedMission.fZoneReactivationSeconds = deleteField();
        this.editedMission.markUsedObjects = deleteField();
      }
    }

    this.editedMission.riddleClues = this.riddleClues;
    this.editedMission.forkSelections = this.forkSelections;
    
    this.editedMission.quizzQuestions = this.quizzQuestions;
    this.editedMission.quizzList = this.quizzList;
    this.editedMission.forkAllowedSelections = this.missionForm.value.forkAllowedSelections;

    this.editedMission.successPopup = this.missionForm.value.successPopup;
    this.editedMission.successGotoNext = this.missionForm.value.successGotoNext;
    this.editedMission.failPopup = this.missionForm.value.failPopup;
    this.editedMission.failGotoNext = this.missionForm.value.failGotoNext;

    this.editedMission.dependencies = dependencies;
    this.editedMission.optionalDependencies = optionalDependencies;
    this.editedMission.timeLimited = this.missionForm.value.timeLimited;
    this.editedMission.isProgressStep = this.missionForm.value.isProgressStep;
    this.editedMission.timeLimitedManual = this.missionForm.value.timeLimitedManual;
    this.editedMission.timeLimitedSeconds = this.missionForm.value.timeLimitedSeconds;
    this.editedMission.isFinalMission = this.missionForm.value.isFinalMission;
    this.editedMission.groupCustomMeetingPoint = this.missionForm.value.groupCustomMeetingPoint;
    
    this.editedMission.isHiddenWhileInactive = this.missionForm.value.isHiddenWhileInactive;

    if(this.customIcon){
      this.editedMission.customIcon = this.customIcon;
    }
    else if(this._mission.id){
      this.editedMission.customIcon = deleteField();
    }
    if(this.editedMission.successDispatch && !(this.editedMission.dispatchIndex>=0)){
      this.editedMission.dispatchIndex = 0;
    }

    if(this._mission.id){
      //Update existing document
      this.missionService.updateMission(this._mission, Object.assign({}, this.editedMission))
      .then(res => {
        console.log('Update result:'+JSON.stringify(res));
        this.saved.emit(this.editedMission);
        this.showToast('Success', 'success', `Update Mission success`, 'done-all-outline')
      }).catch(error => {
        console.log('error',error)
        this.showToast('Error', 'danger', `Update Mission failed`, 'close-outline')
      });
    }
    else{
      console.log('Create new mission:'+JSON.stringify(this.editedMission));
      this.missionService.addMission(this.editedMission)
      .then(res => {
        console.log('Create result:'+res);
        //this.goBack();
        this.editedMission.id = res.id;
        this.mission = this.editedMission;
        //this.loadMissionData();
        this.showToast('Success', 'success', `Mission successfully added`, 'done-all-outline')
      }).catch(error => {
        console.log('error',error)
        this.showToast('Error', 'danger', `Add Mission failed`, 'close-outline')
      });
    }
  }

  showToast(type,status ,text, iconName) {
    const icon: NbIconConfig = { icon: iconName, pack: 'eva' };
    let duration = 5000
    let position = this.positions.TOP_RIGHT
    this.toastrService.show(type , text, { position, status, duration,icon });
  }

  duplicateMission(event){
    event.stopPropagation();
    //console.log('duplicate:'+this.templateId);
    this.missionService.copyMission(this._template ? this._template.id : null, this.gameId, this._mission.id)
    .subscribe(res => {
      console.log('Copymission result:'+res);
    });
  }

  copyFromTemplate(){
    this.copyingFromTemplate = true;
    this.missionService.updateMissionFromTemplate(this.gameId,this._mission.id,this._template ? this._template.id : null,this.templateMissionId)
    .subscribe(res => {
      console.log('copyFromTemplate result:'+res);
      this.copyingFromTemplate = false;
    });
  }

  openPreview(){
    const url = this.router.serializeUrl(
      this.router.createUrlTree([this.getPreviewPath()])
    );
    console.log('Url is:'+url);
    window.open(url, "_blank");
  }

  getPreviewPath(){
    return '/pages/'+(this.gameId ? 'game' : 'template')+'/'+(this.gameId ? this.gameId : this._template.id)+'/overview/'+this._mission?.id;
  }

  async save(data){
    console.log('Update mission with data:'+JSON.stringify(data));
    await this.missionService.updateMission(this._mission, data)
  }

}
